module.exports = __webpack_public_path__ + "99f9f297bce13658ed4da2e12115a6ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/train/view/home/images/more.png
// module id = 110
// module chunks = 1